<div class="container mt-5">
  <div class="row">
    <div class="col-7 mx-auto ">
      <div class="card flex-row my-5 border-0 shadow">
        <div class="card-body p-4 p-sm-5">
          <div class="d-flex justify-content-center">
            <img src="./assets/identity/logo.png" style="width: 30%;">
            <!-- <h3 class="card-title text-start mb-4 ">Login</h3> -->
          </div>
          <hr>
          <form [formGroup]="formForget" (ngSubmit)="onLogin()">
            <div class="form-group" style="text-align: start;">
              <label for="email">{{'email' | translate}}</label>
              <input type="email" formControlName="email" class="form-control" />
            </div>
            <div class="d-flex justify-content-center">
              <button [disabled]="formForget.invalid || formForget.pristine" class="btn btn-primary">
                {{"submit"|translate}}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>

</div>
